import { useState } from 'react';
import { CONTACT_SUCESS_MSG, CONTACT_ERROR_MSG, NAME_ERROR, INVALID_EMAIL_ERROR, INVALID_MOBILE_LENGTH_ERROR, ALL_FIELD_ERROR, INVALID_MESSAGE_ERROR, CONTACT_FORM_URL, ACCESS_KEY } from '../../constant/constant';

const useContactForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobileNumber: "",
        service: "",
        message: "",
    });
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

    // ---- Input Handler ----
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // ---- Validator ----
    const validateForm = () => {
        const { name, email, mobileNumber, service, message } = formData;

        if (!name || !email || !mobileNumber || !service || !message) {
            setErrorMessage(ALL_FIELD_ERROR);
            return false;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setErrorMessage(INVALID_EMAIL_ERROR);
            return false;
        }

        if (mobileNumber.length < 10) {
            setErrorMessage(INVALID_MOBILE_LENGTH_ERROR);
            return false;
        }

        if (message.length < 5 || message.length > 500) {
            setErrorMessage(INVALID_MESSAGE_ERROR);
            return false;
        }

        if (name.length < 3 || name.length > 50) {
            setErrorMessage(NAME_ERROR);
            return false;
        }

        setErrorMessage("");
        return true;
    };

    // ---- Submit Handler ----
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            setIsError(true);
            setIsSuccess(false);
            return;
        }

        try {
            const formData = new FormData(e.target);
            formData.append("access_key", ACCESS_KEY);
            const response = await fetch(CONTACT_FORM_URL, {
                method: "POST",
                body: formData
            });
            const data = await response.json();
            // const data = { success: true }; // Mock response for demonstration
            if (data?.success) {
                // console.log(data.success ? "Success!" : "Error", "=========================");
                setIsSuccess(true);
                setIsError(false);
                setSuccessMessage(CONTACT_SUCESS_MSG);

                // Reset form
                setFormData({
                    name: "",
                    email: "",
                    mobileNumber: "",
                    service: "",
                    message: "",
                });
            } else {
                setIsError(true);
                setIsSuccess(false);
                setErrorMessage(CONTACT_ERROR_MSG);
            }
        } catch (error) {
            // console.error("Form submit error:", error);
            setIsError(true);
            setIsSuccess(false);
            setErrorMessage(CONTACT_ERROR_MSG);
        }
    };

    return {
        formData,
        handleChange,
        handleSubmit,
        isSuccess,
        isError,
        successMessage,
        errorMessage,
    };
};

export default useContactForm;